import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.addDeterminant.success:
        case constants.addSimpleDeterminant.success:
        case constants.getDeterminant.success: {
            return action.payload;
        }

        case constants.clearDeterminant.toString(): {
            return initialState;
        }

        default:
            return state;
    }
}
